<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'wms-tareas-manuales' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <h5 class="form-header">
                Información de tarea #
                <u>{{ current.numero }}</u>
                <div class="st-meta float-right">
                  <br />
                  <button @click="refreshCurrent()" class="btn btn-md btn-info">
                    <i class="fas fa-sync"></i> Actualizar Info.
                  </button>
                  &nbsp;
                  <div class="element-actions">
                    <div class="btn-group">
                      <button
                        :disabled="!current.id"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          type="button"
                          :disabled="!(current.estado != '9')"
                          data-toggle="modal"
                          data-target="#modalAsignarUsuario"
                        >
                          <i class="fa fa-user"></i>
                          &nbsp; Asignar usuario
                        </button>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <div class="row col-12">
                <div v-if="current.tienda_origen_obj" class="col-sm-2">
                  <label>Tienda origen</label>
                  <input
                    :disabled="true"
                    type="text"
                    class="form-control"
                    v-model="current.tienda_origen_obj.nombre"
                  />
                </div>
                <div v-if="current.tienda_origen_obj" class="col-sm-2">
                  <label>Tienda Destino</label>
                  <input
                    :disabled="true"
                    type="text"
                    class="form-control"
                    v-model="current.tienda_destino_obj.nombre"
                  />
                </div>
                <div class="col-sm-4">
                  <label>Fecha</label>
                  <input
                    v-model="current.fecha_creacion"
                    class="form-control"
                    placeholder="Fecha"
                    :disabled="true"
                    type="text"
                  />
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Usuario creó</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.usuario_crea.username"
                      type="text"
                    />
                  </div>
                </div>
                <div
                  class="col-sm-2"
                  v-if="
                    current.usuario &&
                    current.usuario.username != current.usuario_crea.username
                  "
                >
                  <div class="form-group">
                    <label>Usuario asignado</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.usuario.username"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div>
                <br />
                <div class="col-12">
                  <button
                    :disabled="current.fecha_asignacion"
                    class="btn btn-secondary btn-block"
                    @click="abrirModalAsignarDetalle()"
                  >
                    <i class="fas fa-plus"></i> Agregar detalle a tarea
                  </button>
                </div>
              </div>
              <br />
              <div
                class="table-responsive invoice-table"
                v-if="current.id != null"
              >
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th class="text-right">Cant. solicitada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.detalle"
                      v-bind:key="detalle.id"
                    >
                      <td>
                        {{ detalle.producto }}
                        <br />
                        <small>{{ detalle.producto_obj.nombre }}</small>
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span>{{ detalle.cantidad_solicitada }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <div
          class="modal fade"
          id="modalAsignarUsuario"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  Elije usuario
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <UsuariosSelectComponent :current="currentDetalle" />
              </div>
              <div class="modal-footer">
                <button
                  @click="asignarUsuarioManual()"
                  class="btn btn-success btn-lg"
                >
                  Aceptar <i class="fa fas-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AsignarTareaModalComponent
      :tarea="current"
      :reqs_pendientes="reqs_pendientes"
      @refreshCurrent="refreshCurrent()"
    />
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import AsignarTareaModalComponent from "@/components/wms/tareas_manuales/AsignarTareaModalComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    AsignarTareaModalComponent,
    UsuariosSelectComponent,
  },
  data() {
    return {
      reqs_pendientes: [],
      filter: {},
      currentDetalle: {},
      current: {
        id: null,
        usuario: "",
        usuario_crea: "",
        estado_str: null,
        tienda_origen_obj: null,
        tienda_destino_obj: null,
        fecha: "",
        estado: "",
        tipo: "",
        errors: {
          tienda: "",
          fecha: "",
        },
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    asignarUsuarioManual() {
      let self = this;
      if (!self.currentDetalle.usuario) {
        Notifications.alert.error(
          "Asignar Usuario",
          "¿A que usuario desea asignarlo?"
        );
        return;
      }
      self.currentDetalle.usuario = self.currentDetalle.usuario.id;
      Notifications.alert.confirm(
        "Asignar usuario a tarea",
        "¿Esta seguro?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "tareas",
            self.current.id,
            "asignar_usuario",
            self.currentDetalle
          )
            .then((response) => {
              self.refreshCurrent();
              Notifications.alert.success(
                "Asignar usuario",
                "Realizado Exitosamente"
              );
              $("#modalAsignarUsuario").modal("hide");
            })
            .catch((error) => {
              Notifications.alert.error(
                "Asignar usuario",
                error.response.data.detail
              );
            });
        }
      );
    },
    abrirModalAsignarDetalle() {
      let self = this;
      $("#ModalAggDetalleSolicitud").modal("show");
    },
    refreshRequisicionesPendientes() {
      let self = this;
      self.filter.tienda_origen = self.current.tienda_origen;
      self.filter.tienda_destino = self.current.tienda_destino;
      DynamicService.getActionList(
        "wms",
        "tareas",
        "obtener_reqs_para_tarea_manual",
        self.filter
      ).then((response) => {
        self.reqs_pendientes = response.data;
      });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("wms", "tareas", self.$route.params.id)
        .then((res) => {
          self.current = res.data;
          self.current.fecha_creacion = self.customFormatter(
            self.current.fecha_creacion
          );
        })
        .catch((err) => {});
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY hh:mm:s a");
    },
  },
};
</script>
